import * as Yup from 'yup'

export const getValidationSchema = (editItem: AdminStore) =>
  Yup.object().shape({
    code: Yup.object()
      .shape({
        label: Yup.string(),
        value: Yup.string()
      })
      .required('Campul este obligatoriu.'),
    metiVersion: Yup.object()
      .shape({
        label: Yup.string().required('Campul este obligatoriu.'),
        value: Yup.string().required('Campul este obligatoriu.')
      })
      .required('Campul este obligatoriu.'),
    adCode: Yup.string().required('Campul este obligatoriu.'),
    parentSociety: Yup.object()
      .shape({
        label: Yup.string().required('Campul este obligatoriu.'),
        value: Yup.string().required('Campul este obligatoriu.')
      })
      .required('Campul este obligatoriu.'),
    receptionDeviation: Yup.number().required('Campul este obligatoriu.'),
    sftpIp: Yup.string().required('Campul este obligatoriu.'),
    sftpPath: Yup.string().required('Campul este obligatoriu.'),
    metiGrappe: Yup.string(),
    depositIds: Yup.array()
      .of(
        Yup.object().shape({
          label: Yup.string().required('Campul este obligatoriu.'),
          value: Yup.string().required('Campul este obligatoriu.')
        })
      )
      .required('Campul este obligatoriu.'),
    address: Yup.string().required('Campul este obligatoriu.'),
    city: Yup.string().required('Campul este obligatoriu.'),
    town: Yup.string().required('Campul este obligatoriu.'),

    canEditQuantities: Yup.boolean(),
    canCallReturnTruck: Yup.boolean(),
    active: Yup.boolean().required('Campul este obligatoriu.')
  })

export function getManagerValidationSchema(editItem?: AdminStore) {
  return Yup.object({
    receptionDeviation: getValidationSchema(editItem).fields
      .receptionDeviation as Yup.NumberSchema,
  })
}

export const getInitialValues = (editItem: AdminStore, depositsOptions: AutocompleteOption[], isEdit: boolean) => {
  return {
    id: editItem?.id || null,
    code: editItem ? { label: editItem?.metiCode, value: editItem?.metiCode } : null,
    metiVersion: editItem ? { label: editItem?.metiVersion, value: editItem?.metiVersion } : null,
    adCode: editItem?.adCode || '',
    parentSociety: editItem
      ? { label: editItem?.parentSociety, value: editItem?.parentSociety }
      : null,
    receptionDeviation: editItem?.receptionDeviation || 0,
    sftpIp: editItem?.sftpIp || '',
    sftpPath: editItem?.sftpPath || '',
    metiGrappe: editItem?.metiGrappe || '',
    address: editItem?.address || '',
    city: editItem?.city || '',
    town: editItem?.town || '',
    canEditQuantities: editItem?.canEditQuantities || false,
    canCallReturnTruck: editItem?.canCallReturnTruck || false,
    active: isEdit ? Boolean(editItem?.active) : true,
    depositIds: depositsOptions || []
  }
}
